// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*고객 정보 팝업*/
.CustomerSendListPopup_customer_send_list_pop__qN6r9{
    position: absolute;
    width: 363px;
    height: 363px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 17px 20px; box-sizing: border-box;
    z-index: 9999;
    display: block;
}

.CustomerSendListPopup_customer_send_list_pop__qN6r9 .CustomerSendListPopup_tit__5146h{
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 15px;
    display: flex;
}

.CustomerSendListPopup_customer_send_list_pop__qN6r9 .CustomerSendListPopup_tit__5146h .CustomerSendListPopup_close_btn__t3nxJ{margin-left: auto;cursor: pointer;}
.CustomerSendListPopup_customer_send_list_pop__qN6r9 .CustomerSendListPopup_tit__5146h .CustomerSendListPopup_close_btn__t3nxJ svg{position: relative; top: 2px;}
.CustomerSendListPopup_customer_send_list_pop__qN6r9 .CustomerSendListPopup_tit__5146h .CustomerSendListPopup_title__bUn6u{color: #000;}
.CustomerSendListPopup_customer_send_list_pop__qN6r9 label {display:flex; align-items: center; }
.CustomerSendListPopup_customer_send_list_pop__qN6r9 > span{color: #51D7DF;}
.CustomerSendListPopup_customer_send_list_pop__qN6r9 .CustomerSendListPopup_content__Arzkr > p {
    width:100%; margin-bottom: 15px;
    text-align: left;
    color: #000000;
    font-weight: 400;
    display: -webkit-box;
    -webkit-line-clamp: 6; /* 표시하고 싶은 줄 수 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.CustomerSendListPopup_customer_send_list_pop__qN6r9 .CustomerSendListPopup_cst_list__ybYBB {
    display: flex;
    margin-top: 10px;
    gap: 8px;
    flex-wrap: wrap;
}

/* customer list css */
.CustomerSendListPopup_cst_list__ybYBB .CustomerSendListPopup_cst_item__e7DHo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap:8px;
    padding: 2px 5px;
    background:#fff;
    color: black;
    border: 1px solid #51D7DF;
    border-radius:10px;
    cursor:pointer;
}

.CustomerSendListPopup_cst_list__ybYBB .CustomerSendListPopup_cst_item__e7DHo span {
    max-width:90px;
    color: black;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
}
.CustomerSendListPopup_cst_list__ybYBB .CustomerSendListPopup_cst_item__e7DHo button {
    background: #51D7DF;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 3px 5px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomerSendListPopup.module.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAER,gDAAgD;IACxD,kBAAkB,EAAkC,sBAAsB;IAC1E,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IAGnB,aAAa;AACjB;;AAEA,+HAAwC,iBAAiB,CAAC,eAAe,CAAC;AAC1E,mIAA4C,kBAAkB,EAAE,QAAQ,CAAC;AACzE,2HAAoC,WAAW,CAAC;AAChD,4DAA+B,YAAY,EAAE,mBAAmB,EAAE;AAClE,4DAA+B,cAAc,CAAC;AAC9C;IACI,UAAU,EAAE,mBAAmB;IAC/B,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB,EAAE,gBAAgB;IACvC,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IAGI,aAAa;IACb,gBAAgB;IAChB,QAAQ;IAEJ,eAAe;AACvB;;AAEA,sBAAsB;AACtB;IAGI,aAAa;IAGL,uBAAuB;IAGvB,mBAAmB;IAC3B,mBAAmB;IACnB,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;;AAE3B;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":["/*고객 정보 팝업*/\n.customer_send_list_pop{\n    position: absolute;\n    width: 363px;\n    height: 363px;\n    border-radius: 20px;\n    background: #FFF;\n    -webkit-box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);\n            box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);\n    padding: 17px 20px; -webkit-box-sizing: border-box; box-sizing: border-box;\n    z-index: 9999;\n    display: block;\n}\n\n.customer_send_list_pop .tit{\n    font-size: 16px;\n    font-weight: 700;\n    margin-bottom: 15px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.customer_send_list_pop .tit .close_btn{margin-left: auto;cursor: pointer;}\n.customer_send_list_pop .tit .close_btn svg{position: relative; top: 2px;}\n.customer_send_list_pop .tit .title{color: #000;}\n.customer_send_list_pop label {display:flex; align-items: center; }\n.customer_send_list_pop > span{color: #51D7DF;}\n.customer_send_list_pop .content > p {\n    width:100%; margin-bottom: 15px;\n    text-align: left;\n    color: #000000;\n    font-weight: 400;\n    display: -webkit-box;\n    -webkit-line-clamp: 6; /* 표시하고 싶은 줄 수 */\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.customer_send_list_pop .cst_list {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-top: 10px;\n    gap: 8px;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n\n/* customer list css */\n.cst_list .cst_item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    flex-direction: row;\n    gap:8px;\n    padding: 2px 5px;\n    background:#fff;\n    color: black;\n    border: 1px solid #51D7DF;\n    border-radius:10px;\n    cursor:pointer;\n}\n\n.cst_list .cst_item span {\n    max-width:90px;\n    color: black;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    \n}\n.cst_list .cst_item button {\n    background: #51D7DF;\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    padding: 3px 5px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customer_send_list_pop": `CustomerSendListPopup_customer_send_list_pop__qN6r9`,
	"tit": `CustomerSendListPopup_tit__5146h`,
	"close_btn": `CustomerSendListPopup_close_btn__t3nxJ`,
	"title": `CustomerSendListPopup_title__bUn6u`,
	"content": `CustomerSendListPopup_content__Arzkr`,
	"cst_list": `CustomerSendListPopup_cst_list__ybYBB`,
	"cst_item": `CustomerSendListPopup_cst_item__e7DHo`
};
export default ___CSS_LOADER_EXPORT___;
